module.exports = __webpack_public_path__ + "static/media/1.0023d2cd.jpg";